export const SERVER_URL = process.env.REACT_APP_SERVER_URL;
export const APP_AUTH_URL = process.env.REACT_APP_AUTH_URL;
export const APP_AUTH_LOGOUT = process.env.REACT_APP_AUTH_LOGOUT;
export const APP_VERSION = process.env.REACT_APP_VERSION;
export const APP_ENVIRONMENT = process.env.REACT_APP_ENVIRONMENT;


